import { formatMoney, formatMoneyMinor } from '@metapic-apps/shared'

import { resolveUserIntlLocale } from '@/lib/helpers'

/** Advertiser policy: shared numeric separators with locally positioned symbols and configured minor units. */
const currencyLocaleMap = new Set([
  'AUD',
  'CAD',
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'NOK',
  'PLN',
  'RUB',
  'SEK',
  'USD',
])

const advertiserMoneyOptions = (
  money: Parameters<typeof formatMoney>[0],
  options: Parameters<typeof formatMoney>[1],
) => {
  if (!money?.currency) {
    return { ...options, locale: 'en-GB' }
  }

  const currencyLocale =
    options?.currencyLocale ??
    (currencyLocaleMap.has(money.currency) ? undefined : resolveUserIntlLocale(options?.locale))

  return {
    ...options,
    locale: 'en-GB',
    ...(currencyLocale ? { currencyLocale } : {}),
  }
}

/** Advertiser policy with symbols and fixed major-unit decimal digits. */
export const formatMoneyForAdvertiser: typeof formatMoney = (money, options) =>
  formatMoney(money, advertiserMoneyOptions(money, options))

/** Advertiser default display policy, retaining configured minor currency units. */
export const formatMoneyMinorForAdvertiser: typeof formatMoney = (money, options) =>
  formatMoneyMinor(money, advertiserMoneyOptions(money, options))
